import { DIFFICULTY_RATINGS } from "./difficulty-ratings"
export const TOURS_PER_PAGE = 15

export const TOUR_PRICE_OPTIONS = {
  currency: process.env.GATSBY_TOURS_PRICE_RANGE_CURRENCY,
  min: parseFloat(process.env.GATSBY_TOURS_PRICE_RANGE_MIN),
  max: parseFloat(process.env.GATSBY_TOURS_PRICE_RANGE_MAX),
  maxRound: parseFloat(process.env.GATSBY_TOURS_PRICE_RANGE_MAX_ROUND),
  step: parseFloat(process.env.GATSBY_TOURS_PRICE_RANGE_STEP),
}
export const TOUR_SEARCH_CURRENCY = process.env.GATSBY_SEARCH_CURRENCY

export const TOUR_SORT_BY_OPTIONS = [
  {
    text: "Alphabetically (A to Z)",
    value: "Alpha_ASC",
  },
  {
    text: "Alphabetically (Z to A)",
    value: "Alpha_DESC",
  },
  {
    text: "Price (lowest first)",
    value: "Price_ASC",
  },
  {
    text: "Price (highest first)",
    value: "Price_DESC",
  },
]
export const TOUR_SORT_BY_OPTION_DEFAULT = "Price_ASC"

export const TOUR_DURATION_OPTIONS = [
  {
    text: "1-3 days",
    value: { durationMin: 1, durationMax: 3 },
  },
  {
    text: "4-7 days",
    value: { durationMin: 4, durationMax: 7 },
  },
  {
    text: "8-14 days",
    value: { durationMin: 8, durationMax: 14 },
  },
  {
    text: "15-30 days",
    value: { durationMin: 15, durationMax: 30 },
  },
]

export const TOUR_DIFFICULTY_OPTIONS = DIFFICULTY_RATINGS.map(
  ({ title, ...rating }) => ({
    text: title,
    ...rating,
  })
)
